"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Icon_1 = __importDefault(require("../Icon"));
var Link_1 = __importDefault(require("../Link"));
var Image_1 = __importDefault(require("../Image"));
var Box_1 = __importDefault(require("../Box"));
function SocialIcon(props) {
    var socialLinks = props.socialLinks;
    var ref = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(0), right = _a[0], setRight = _a[1];
    var handleMouseOver = function () {
        if (!ref.current)
            return;
        var rect = ref.current.getBoundingClientRect();
        // offset image to keep it within the screen
        setRight(rect.x);
    };
    var handleMouseLeave = function () {
        // reset to 0 so the offset won't accumulate
        setRight(0);
    };
    return (react_1.default.createElement(Container, null, socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.map(function (item) { return (react_1.default.createElement(Link_1.default, { key: item.url, href: item.url }, isImage(item.url)
        ?
            react_1.default.createElement(HoverableIcon, { name: item.icon, onMouseOver: handleMouseOver, onMouseLeave: handleMouseLeave },
                react_1.default.createElement(ImagePopover, { ref: ref, src: item.url, right: right, alt: "social icon" }))
        : react_1.default.createElement(Icon_1.default, { name: item.icon, color: "white" }))); })));
}
var Container = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            justifyContent: 'space-evenly',
            marginTop: '42px',
            marginBottom: '20px'
        },
        _b[theme.mediaQueries.md] = {
            justifyContent: 'start',
            gap: '30px',
            paddingLeft: '36px',
        },
        _b[theme.mediaQueries.lg] = {
            paddingLeft: '150px',
        },
        _b);
});
var ImagePopover = (0, styled_1.default)(Image_1.default)({
    position: 'absolute',
    maxWidth: 'initial',
    height: 256,
    width: 256,
    bottom: 25,
});
var HoverableIcon = (0, styled_1.default)(Icon_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        color: 'white',
        '&>img': {
            display: 'none'
        },
        '&:hover>img': {
            display: 'block',
            zIndex: theme.zIndices.tooltip // z-index greater than the back-top
        },
    });
});
function isImage(url) {
    return /\.(jpe?g|png|gif)$/i.test(url);
}
exports.default = SocialIcon;
